export default function ClueCard({
  category,
  clue,
  answer,
  revealAnswer = false,
  accent = "purple",
}) {
  const accentClass = `clue-card--${accent}`;

  return (
    <section className={`clue-card ${accentClass}`}>
      <div className="clue-card__inner">
        {category ? (
          <div className="clue-card__category" aria-label="Category">
            {category}
          </div>
        ) : null}

        <div className="clue-card__body">
          <p className="clue-card__clue">{clue}</p>
        </div>

        {revealAnswer && (
          <div className="clue-card__answer-wrap clue-card__answer-wrap--visible">
            <div className="clue-card__divider" />
            <p className="clue-card__answer-label">Answer</p>
            <p className="clue-card__answer">{answer}</p>
          </div>
        )}
      </div>
    </section>
  );
}